import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a3be680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-input flex flex-col" }
const _hoisted_2 = { class: "flex flex-row w-full" }
const _hoisted_3 = ["for"]
const _hoisted_4 = {
  key: 0,
  class: "text-color-rejected"
}
const _hoisted_5 = ["placeholder", "id"]
const _hoisted_6 = {
  key: 1,
  class: "w-10/12"
}
const _hoisted_7 = { class: "flex flex-row w-full" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-2/12" }, "   ", -1))
const _hoisted_9 = { class: "w-10/12" }
const _hoisted_10 = {
  key: 0,
  class: "text-color-rejected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: "form-input__label w-2/12 flex items-end",
        for: _ctx.id
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.label)) + " ", 1),
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_3),
      (!_ctx.$slots.control)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            class: "form-input__control border-2 w-10/12",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            placeholder: _ctx.translatedPlaceholder,
            id: _ctx.id
          }, null, 8, _hoisted_5)), [
            [_vModelText, _ctx.value]
          ])
        : _createCommentVNode("", true),
      (_ctx.$slots.control)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "control", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}